import { WidgetType } from '../types/WidgetType';

export const isTabletopLikeWidget = (widgetType: WidgetType): boolean =>
  widgetType === WidgetType.TABLETOP || widgetType === WidgetType.ANF_TABLETOP;
